/* tslint:disable */
/* eslint-disable */
/**
 * Clients API
 * API des listes de clients (personnes ayant au moins un contrat)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Un client = une personne (physique ou morale) ayant au moins un contrat dans le périmètre. Champs email/phone/customerSince absents si null.
 * 
 * @export
 * @interface ClientListItem
 */
export interface ClientListItem {
    /**
     * 
     * @type {string}
     * @memberof ClientListItem
     */
    id: string;
    /**
     * "Prénom Nom" (personne physique) ou désignation (personne morale)
     * @type {string}
     * @memberof ClientListItem
     */
    name: string;
    /**
     * true = personne morale
     * @type {boolean}
     * @memberof ClientListItem
     */
    isCompany: boolean;
    /**
     * Absent si null
     * @type {string}
     * @memberof ClientListItem
     */
    email?: string | null;
    /**
     * Absent si null
     * @type {string}
     * @memberof ClientListItem
     */
    phone?: string | null;
    /**
     * Date du 1er contrat. Absent si null.
     * @type {Date}
     * @memberof ClientListItem
     */
    customerSince?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ClientListItem
     */
    contractCount: number;
    /**
     * Compte tous les risques où la personne apparaît (léger sur-comptage possible côté courtier)
     * @type {number}
     * @memberof ClientListItem
     */
    simulationCount: number;
    /**
     * >= 1 contrat en cours
     * @type {boolean}
     * @memberof ClientListItem
     */
    hasActiveContract: boolean;
    /**
     * Prime TTC cumulée des quittances
     * @type {number}
     * @memberof ClientListItem
     */
    totalPremium: number;
    /**
     * Codes des branches d'assurance des contrats du client
     * @type {Array<string>}
     * @memberof ClientListItem
     */
    branches: Array<string>;
    /**
     * Codes des produits des contrats du client (miroir de branches)
     * @type {Array<string>}
     * @memberof ClientListItem
     */
    products: Array<string>;
    /**
     * Courtier de rattachement. Rempli uniquement en vue partagée (rôle Plateforme / portefeuille partagé) ; null/absent (WhenWritingNull) en vue courtier classique — détecteur d'affichage de la colonne « Courtier ».
     * 
     * @type {string}
     * @memberof ClientListItem
     */
    brokerId?: string | null;
    /**
     * Nom du courtier (cf. brokerId). Renseigné en vue partagée uniquement.
     * @type {string}
     * @memberof ClientListItem
     */
    brokerName?: string | null;
}

/**
 * Check if a given object implements the ClientListItem interface.
 */
export function instanceOfClientListItem(value: object): value is ClientListItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isCompany' in value) || value['isCompany'] === undefined) return false;
    if (!('contractCount' in value) || value['contractCount'] === undefined) return false;
    if (!('simulationCount' in value) || value['simulationCount'] === undefined) return false;
    if (!('hasActiveContract' in value) || value['hasActiveContract'] === undefined) return false;
    if (!('totalPremium' in value) || value['totalPremium'] === undefined) return false;
    if (!('branches' in value) || value['branches'] === undefined) return false;
    if (!('products' in value) || value['products'] === undefined) return false;
    return true;
}

export function ClientListItemFromJSON(json: any): ClientListItem {
    return ClientListItemFromJSONTyped(json, false);
}

export function ClientListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'isCompany': json['isCompany'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'customerSince': json['customerSince'] == null ? undefined : (new Date(json['customerSince'])),
        'contractCount': json['contractCount'],
        'simulationCount': json['simulationCount'],
        'hasActiveContract': json['hasActiveContract'],
        'totalPremium': json['totalPremium'],
        'branches': json['branches'],
        'products': json['products'],
        'brokerId': json['brokerId'] == null ? undefined : json['brokerId'],
        'brokerName': json['brokerName'] == null ? undefined : json['brokerName'],
    };
}

export function ClientListItemToJSON(json: any): ClientListItem {
    return ClientListItemToJSONTyped(json, false);
}

export function ClientListItemToJSONTyped(value?: ClientListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'isCompany': value['isCompany'],
        'email': value['email'],
        'phone': value['phone'],
        'customerSince': value['customerSince'] == null ? undefined : ((value['customerSince'] as any).toISOString()),
        'contractCount': value['contractCount'],
        'simulationCount': value['simulationCount'],
        'hasActiveContract': value['hasActiveContract'],
        'totalPremium': value['totalPremium'],
        'branches': value['branches'],
        'products': value['products'],
        'brokerId': value['brokerId'],
        'brokerName': value['brokerName'],
    };
}

